//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import Filters from './UserReferralChargesFilters.vue';
import GetReport from '~/components/GetReport.vue';
import constant from '~/const';

// ALL THIS PAGE IS ON TODO LIST

export default {
  components: {
    Filters,
    GetReport,
  },

  data() {
    return {
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),
    ...mapGetters('leadsStatistics', ['requestData']),
    ...mapState('leadsStatistics', ['pages']),
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader', 'setGeneralProgress', 'setSuccessNotification', 'setErrorNotification']),
  },
};
